import { Nullable } from '../type'

export const round = (num: number) =>
  Math.round((num + Number.EPSILON) * 100) / 100;

export const resolveNumber = (
  number: Nullable<number>,
  options?: { changeNegativeToZero?: boolean }) => {
  let newValue = Number(number || 0)

  if(options?.changeNegativeToZero)
    newValue = newValue >= 0 ? newValue : 0

  return newValue
}

export const compactNumberText = (value: Nullable<number>) => {
  const number = resolveNumber(value)

  for (const divisor of [1000, 100, 10]) {
    const divided = number / divisor

    if (Number.isInteger(divided))
      return String(divided)
  }

  return String(number)
}

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export const usdFormat = (value: number) => usdFormatter.format(value)

